import styles from "./our-app-card.module.scss";
import { OurApp } from "@/components/pages/our-apps/our-apps-page";
import Link from "next/link";

interface OurAppCardProps {
  app: OurApp;
}

const OurAppCard = ({ app }: OurAppCardProps) => {
  return (
    <Link className={styles.app_card} href={app.href} target="_blank">
      <div className={styles.title}>{app.title}</div>
      <div className={styles.href}>{app.description}</div>
    </Link>
  );
};

export default OurAppCard;
